export const headerConstants = { 
    HARD_RESET: 'HARD_RESET'
}